const plateTestFormMixin = {

    methods: {

    }
}

export default plateTestFormMixin;